import { graphql, useStaticQuery } from "gatsby";

interface Query {
  strapiShared: {
    newsletterHeading: string;
    newsletterHeadingEN: string;
    newsletterHeadingDE: string;
    newsletterDescription: {
      data: {
        newsletterDescription: string;
      };
    };
    newsletterDescriptionEN: {
      data: {
        newsletterDescriptionEN: string;
      };
    };
    newsletterDescriptionDE: {
      data: {
        newsletterDescriptionDE: string;
      };
    };
  };
}

const useNewsletterData = () => {
  return useStaticQuery<Query>(graphql`
    {
      strapiShared {
        newsletterHeading
        newsletterHeadingEN
        newsletterHeadingDE
        newsletterDescription {
          data {
            newsletterDescription
          }
        }
        newsletterDescriptionEN {
          data {
            newsletterDescriptionEN
          }
        }
        newsletterDescriptionDE {
          data {
            newsletterDescriptionDE
          }
        }
      }
    }
  `);
};

export { useNewsletterData, type Query };
